export const GET_TAX_REVENUE_TYPES =
  'TAX_REVENUE_TYPES/get_tax_revenue_types';
export const GET_SINGLE_TAX_REVENUE_TYPES =
  'TAX_REVENUE_TYPES/get_single_tax_revenue_types';
export const UPDATE_TAX_REVENUE_TYPES =
  'TAX_REVENUE_TYPES/update_tax_revenue_types';
export const CREATE_TAX_REVENUE_TYPES =
  'TAX_REVENUE_TYPES/create_tax_revenue_types';
export const REMOVE_TAX_REVENUE_TYPES =
  'TAX_REVENUE_TYPES/remove_tax_revenue_types';

export const FORM_DATA = {
  code: '',
  name: '',
  description: '',
  type: '',
  with_quarterly_calculation: 0,
  cumulative_amount_or: 0
};

export const TYPES = [
  {
    label: 'Multiple',
    value: 'MULTIPLE',
  },
  {
    label: 'Highest',
    value: 'HIGHEST',
  },
  {
    label: 'Cumulative',
    value: 'CUMULATIVE',
  }
];
